module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "contentWrapper",
    staticClass: "content-wrapper",
    style: ('min-height: ' + _vm.alturaContentWrapper + 'px'),
    attrs: {
      "id": "validacoes"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - ' + _vm.enumeradores[_vm.validacao]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('p', {
    staticClass: "visible-xs"
  }, [_vm._v(" ")]), _vm._v(" "), _c('h1', {
    staticClass: "col-lg-5 col-md-6 col-sm-12 text-left"
  }, [_vm._v("\n        " + _vm._s(_vm.enumeradores[_vm.validacao]) + "\n\n        "), (_vm.mostrarProcesso.length === 0) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostraCarregando),
      expression: "!mostraCarregando"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-caret-down opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Abre as seções principais</h5>'
    },
    on: {
      "click": function($event) {
        _vm.mostrarProcesso = _vm._.keys(_vm.listaValidacoes);
        _vm.$refs['contentWrapper'].scrollIntoView()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mostrarProcesso.length > 0 || _vm.mostrarAtividade.length > 0) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mostraCarregando),
      expression: "!mostraCarregando"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "fa fa-caret-up opcao",
    attrs: {
      "aria-hidden": "true",
      "title": '<h5>Fecha todas as seções</h5>'
    },
    on: {
      "click": function($event) {
        _vm.mostrarProcesso = [];
        _vm.mostrarAtividade = [];
        _vm.$refs['contentWrapper'].scrollIntoView()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.enumeradores[_vm.validacao] === 'Execução financeira') ? _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true,
        delay: [500, 0],
        placement: 'right'
      }),
      expression: "{\n              inertia:true,\n              arrow:true,\n              animation:'perspective',\n              distance:'1',\n              size:'large',\n              arrow:true,\n              delay: [500, 0],\n              placement: 'right'}"
    }],
    staticClass: "semaforo",
    attrs: {
      "src": require("../../../../static/img/farol_2.png"),
      "title": '<h5 style=\'text-align:left\'><b>Pagamento, Ressarcimento e Adiantamento*</b></br><span style=\'text-align: left\'>' +
        '<p></p>' +
        '<p><i class=\'fa fa-square\' style=\'color:#218D1E\'></i> até 3 dias úteis</p>' +
        '<p><i class=\'fa fa-square\' style=\'color:#DBC112\'></i> de 4 a 5 dias úteis</p>' +
        '<p><i class=\'fa fa-square\' style=\'color:#A3100F\'></i> a partir do 6º dia útil</p>' +
        '<hr></span></h5>' +
        '<h5 style=\'text-align:left\'><b>Prestação de Contas e Devolução de Adiantamento*</b></br><span style=\'text-align:left\'' +
        '<p></p>' +
        '<p><i class=\'fa fa-square\' style=\'color:#218D1E\'></i> até 6 dias úteis</p>' +
        '<p><i class=\'fa fa-square\' style=\'color:#DBC112\'></i> de 7 a 10 dias úteis</p>' +
        '<p><i class=\'fa fa-square\' style=\'color:#A3100F\'></i> a partir do 11º dia útil</p>' +
        '<hr></span></h5>' +
        '<h5><p><b>*por limitações técnicas, os feriados são computados como dias úteis</b></p></h5>'
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-7 col-md-6 col-sm-5"
  }, [_c('div', {
    staticClass: "col-md-8 pull-right"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pesquisa),
      expression: "pesquisa"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    ref: "caixaPesquisa",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Pesquisa...",
      "title": '<h5>Digite uma palavra ou número e pressione Enter</h5>'
    },
    domProps: {
      "value": (_vm.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.filtrar()
      },
      "focus": function($event) {
        return $event.target.select()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pesquisa = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.pesquisa.length > 0) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "input-group-btn",
    attrs: {
      "title": '<h5>Limpar essa pesquisa</h5>'
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "white",
      "border-color": "#d2d6de",
      "border-width": "1px 0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.pesquisa = '';
        _vm.filtrar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  })])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "disabled": !_vm.pesquisa,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.filtrar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-3 col-sm-7 text-lg-left"
  }, [_c('div', {
    staticClass: "truncar",
    staticStyle: {
      "padding-top": "5px",
      "font-size": "18px",
      "color": "darkgray"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "5px",
      "color": "firebrick",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes)))]), _vm._v(" tarefa(s)\n          "), (_vm.tarefasSelecionadas.length > 0) ? _c('span', [_vm._v(" com "), _c('span', {
    staticStyle: {
      "color": "var(--cor-azul)"
    }
  }, [_vm._v(_vm._s(_vm.tarefasSelecionadas.length))]), _vm._v(" selecionada" + _vm._s(_vm.tarefasSelecionadas.length > 1 ? 's' : ''))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8 col-md-9 col-sm-12 text-right",
    staticStyle: {
      "line-height": "2em"
    }
  }, [_c('span', {
    staticClass: "indicadores-cb-inline"
  }, [_c('div', {
    staticClass: "juntos",
    attrs: {
      "disabled": _vm.mostraProcessando
    }
  }, [_c('i', {
    class: (_vm.selecionarTodasTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.selecionarTodasTarefas = (_vm.selecionarTodasTarefas === 'nao') ? 'sim' : 'nao'
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.selecionarTodasTarefas === 'nao' ? '' : 'selecionado'
  }, [_vm._v("Selecionar tudo")])]), _vm._v(" "), _c('div', {
    staticClass: "juntos"
  }, [_c('i', {
    class: (_vm.meusFavoritados === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.meusFavoritados = (_vm.meusFavoritados === 'nao') ? 'sim' : 'nao'
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.meusFavoritados === 'nao' ? '' : 'selecionado'
  }, [_vm._v("Favoritos")])]), _vm._v(" "), _c('div', {
    staticClass: "juntos"
  }, [_c('i', {
    class: (_vm.minhasTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.minhasTarefas = (_vm.minhasTarefas === 'nao') ? 'sim' : 'nao'
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.minhasTarefas === 'nao' ? '' : 'selecionado'
  }, [_vm._v("Minhas Tarefas")])]), _vm._v(" "), _c('div', {
    staticClass: "juntos"
  }, [_c('i', {
    class: (_vm.somenteComTarefas === 'nao' ? 'fa fa-square-o' : 'fa fa-check-square-o selecionado'),
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.somenteComTarefas = (_vm.somenteComTarefas === 'nao') ? 'sim' : 'nao'
      }
    }
  }), _vm._v(" "), _c('span', {
    class: _vm.somenteComTarefas === 'nao' ? '' : 'selecionado'
  }, [_vm._v("Somente com Tarefas")])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ordenacao.por),
      expression: "ordenacao.por"
    }, {
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "auto",
      "float": "left"
    },
    attrs: {
      "title": '<h5>Selecione por qual critério deseja ordenar</h5>'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.ordenacao, "por", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "id_processo"
    }
  }, [_vm._v("ID")]), _vm._v(" "), (!_vm._.includes(['ENTIDADES', 'PARCEIRO_ESTRATEGICO'], _vm.validacao)) ? _c('option', {
    attrs: {
      "value": "projeto"
    }
  }, [_vm._v("Projeto")]) : _vm._e(), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('option', {
    attrs: {
      "value": "extra.situacao_projeto"
    }
  }, [_vm._v("Situação do Projeto")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "entidade"
    }
  }, [_vm._v("Entidade")]), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('option', {
    attrs: {
      "value": "valor"
    }
  }, [_vm._v("Valor")]) : _vm._e(), _vm._v(" "), _c('option', {
    attrs: {
      "value": "data_solicitacao"
    }
  }, [_vm._v("Data da Solicitação")]), _vm._v(" "), (_vm._.includes(['OCORRENCIAS'], _vm.validacao)) ? _c('option', {
    attrs: {
      "value": "codigo_ocorrencia"
    }
  }, [_vm._v("Código da Ocorrência")]) : _vm._e()]), _vm._v(" "), _c('button', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true}"
    }],
    staticClass: "btn btn-default btn-flat",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "button",
      "title": '<h5>Clique para inverter a ordenação por ' + _vm._.replace(_vm.ordenacao.por, '_', ' ') + '</h5>'
    },
    on: {
      "click": function($event) {
        _vm.ordenacao.ordem = _vm.ordenacao.ordem === 'asc' ? 'desc' : 'asc'
      }
    }
  }, [_c('i', {
    class: 'fa fa-sort-alpha-' + _vm.ordenacao.ordem,
    staticStyle: {
      "font-size": "14px"
    }
  })])])])])]), _vm._v(" "), (_vm.tarefasSelecionadas.length > 0) ? _c('div', {
    staticClass: "col-xs-12 text-left"
  }, [(!_vm.mostraProcessando) ? _c('span', [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "title": '<h5>Favoritar todos os selecionados</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favoritarLote(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star"
  }), _vm._v(" Favoritar\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>Desfavoritar todos os selecionados</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.favoritarLote(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-star-o"
  }), _vm._v(" Desfavoritar\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "title": '<h5>Atribuir a mim todos os selecionado</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.atribuirLote(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Assumir\n          ")]), _vm._v(" "), _c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    attrs: {
      "color": "warning",
      "size": "button--size-ss",
      "title": '<h5>Desatribuir todos os selecionado</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.atribuirLote(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-times"
  }), _vm._v(" Desatribuir\n          ")]), _vm._v(" "), (_vm._.includes(['8600', '8603', '8612', '8613', '8620', '8618', '8622', '8619'], _vm._.get(this.usuarioLogado, 'dadosBB.cod_comissao', ''))) ? _c('span', [_c('g-button-ujarak', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia: true, arrow: true, animation: 'perspective', distance: '1', size: 'large', arrow: true }"
    }],
    attrs: {
      "color": "success",
      "size": "button--size-ss",
      "title": '<h5>Atribuir as tarefas selecionadas a funcionário</h5>'
    },
    nativeOn: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v(" Atribuir\n            ")]), _vm._v(" "), (_vm.showModal) ? _c('div', {
    staticClass: "modal-overlay"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn-close",
    on: {
      "click": _vm.cancelarAtribuicao
    }
  }, [_c('i', {
    staticClass: "fa fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.funcionarioBusca),
      expression: "funcionarioBusca"
    }],
    staticStyle: {
      "display": "inline-block",
      "margin-bottom": "10px",
      "margin-right": "10px"
    },
    attrs: {
      "type": "text",
      "id": "searchFuncionario",
      "placeholder": "Digite o nome ou a matrícula do funcionário"
    },
    domProps: {
      "value": (_vm.funcionarioBusca)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.buscarFuncionario($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.funcionarioBusca = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-confirm",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": _vm.buscarFuncionario
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), (_vm.funcionarioEncontrado) ? _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('p', [_c('strong', [_vm._v("Funcionário:")]), _vm._v(" " + _vm._s(_vm.funcionarioEncontrado.nome))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "-15px"
    }
  }, [_c('strong', [_vm._v("Matrícula:")]), _vm._v(" " + _vm._s(_vm.formatarMatricula(_vm.funcionarioEncontrado.matricula)))])]) : _vm._e(), _vm._v(" "), (_vm.funcionarioEncontrado) ? _c('div', [_c('p', [_vm._v("Deseja realmente atribuir as tarefas selecionadas?")]), _vm._v(" "), _c('div', {
    staticClass: "modal-actions"
  }, [_c('button', {
    staticClass: "btn-confirm",
    on: {
      "click": _vm.confirmarAtribuicao
    }
  }, [_vm._v("Confirmar")]), _vm._v(" "), _c('button', {
    staticClass: "btn-cancel",
    on: {
      "click": _vm.cancelarAtribuicao
    }
  }, [_vm._v("Cancelar")])])]) : _vm._e()])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        arrow: true
      }),
      expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
    }],
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "title": '<h5>Baixar <span class=\'realce\'>' + _vm.tarefasSelecionadas.length + '</span> item(ns) selecionado(s) em Excel</h5>'
    }
  }, [_c('download-excel', {
    attrs: {
      "data": _vm.tarefasSelecionadas,
      "meta": _vm.excel_meta,
      "fields": _vm.excel_campos,
      "type": "xls",
      "name": "validacoes.xls"
    }
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "primary",
      "size": "button--size-ss"
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Baixar planilha\n              ")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mostraProcessando) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content",
    staticStyle: {
      "padding-top": "60px"
    }
  }, [_c('p', {
    staticClass: "visible-sm visible-xs"
  }, [_vm._v(" ")]), _c('p', {
    staticClass: "visible-xs"
  }, [_vm._v(" ")]), _c('p', {
    staticClass: "visible-xs"
  }, [_vm._v(" ")]), _vm._v(" "), (_vm.mostraCarregando) ? _c('h4', {
    staticClass: "box-body text-center"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e(), _vm._v(" "), (_vm.somenteComTarefas === 'sim' && _vm.totalTarefas(_vm.listaValidacoes) === 0) ? _c('h4', {
    staticClass: "box-body"
  }, [_vm._v("Não há tarefas para o filtro selecionado")]) : _vm._e(), _vm._v(" "), _vm._l((_vm._.keysIn(_vm.listaValidacoes)), function(processo) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.mostraCarregando),
        expression: "!mostraCarregando"
      }],
      staticClass: "box box-widget"
    }, [_c('div', {
      staticClass: "box-header"
    }, [_c('h3', {
      staticClass: "box-title"
    }, [_c('span', {
      staticClass: "grupoMostrarOcultar",
      on: {
        "click": function($event) {
          return _vm.mostrar('processo', processo)
        }
      }
    }, [_c('i', {
      class: 'fa fa-caret-' + (!_vm._.isUndefined(_vm._.find(_vm.mostrarProcesso, function(p) {
        return p === processo
      })) ? 'up' : 'down'),
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" " + _vm._s(_vm.enumeradores[processo])), _c('span', {
      staticClass: "contador"
    }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes[processo])))])])]), _vm._v(" "), (processo === 'CONTRAPARTIDA' && _vm.filtroContrapartida) ? _c('div', {
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "filtroCarteira mt-5"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtroCarteiraContrapartida),
        expression: "filtroCarteiraContrapartida"
      }],
      staticClass: "form-control",
      staticStyle: {
        "width": "auto",
        "float": "left"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.filtroCarteiraContrapartida = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          return _vm.onChangeFiltroCarteiraContrapartida()
        }]
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Filtrar por carteira")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Todas as carteiras")]), _vm._v(" "), _vm._l((_vm.carteiras), function(carteira) {
      return _c('option', {
        domProps: {
          "value": carteira
        }
      }, [_vm._v("\n                " + _vm._s(carteira) + "\n              ")])
    })], 2)])]) : _vm._e(), _vm._v(" "), (processo === 'ALTERACOES_PROJETO') ? _c('span', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          placement: 'top',
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', delay: [500, 0]}"
      }],
      staticClass: "pull-right",
      attrs: {
        "title": '<h5>Lista com processos de alteração de projeto nas tarefas listadas abaixo</h5>'
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.meusProcessos),
        expression: "meusProcessos"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.meusProcessos = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, _vm.filtrar]
      }
    }, [_c('option', {
      staticStyle: {
        "color": "var(--cor-destaque)"
      },
      attrs: {
        "value": "",
        "selected": ""
      }
    }, [_vm._v(_vm._s(_vm.meusProcessos === '' ? 'Processos' : 'Limpar Filtro'))]), _vm._v(" "), _vm._l((_vm._.uniq(_vm._.flatten(_vm._.map(_vm._.flatten(_vm._.valuesIn(_vm.listaValidacoes.ALTERACOES_PROJETO)), 'extra.processos')))), function(prc) {
      return _c('option', {
        domProps: {
          "value": prc
        }
      }, [_vm._v(_vm._s(_vm.enumeradores[prc]))])
    })], 2)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          inertia: true,
          arrow: true,
          animation: 'perspective',
          distance: '1',
          size: 'large',
          placement: 'top',
          delay: [500, 0]
        }),
        expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', delay: [500, 0]}"
      }],
      staticClass: "pull-right",
      staticStyle: {
        "margin": "0px 10px"
      },
      attrs: {
        "title": '<h5>Lista com as carteiras nas tarefas listadas abaixo</h5>'
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.minhaCarteira),
        expression: "minhaCarteira"
      }],
      staticClass: "form-control",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.minhaCarteira = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, _vm.filtrar]
      }
    }, [_c('option', {
      staticStyle: {
        "color": "var(--cor-destaque)"
      },
      attrs: {
        "value": "",
        "selected": ""
      }
    }, [_vm._v(_vm._s(_vm.minhaCarteira === '' ? 'Carteiras' : 'Limpar Filtro'))]), _vm._v(" "), _vm._l((_vm._.uniq(_vm._.map(_vm._.flatten(_vm._.valuesIn(_vm.listaValidacoes.ALTERACOES_PROJETO)), 'extra.carteira'))), function(carteira) {
      return _c('option', {
        domProps: {
          "value": carteira
        }
      }, [_vm._v(_vm._s(carteira))])
    })], 2)])]) : _vm._e()]), _vm._v(" "), (!_vm._.isUndefined(_vm._.find(_vm.mostrarProcesso, function(p) {
      return p === processo
    }))) ? _c('div', {
      staticClass: "box-body"
    }, _vm._l((_vm._.keysIn(_vm.listaValidacoes[processo])), function(atividade) {
      return _c('div', {
        staticClass: "box box-widget"
      }, [_c('div', {
        staticClass: "box-header"
      }, [_c('h3', {
        staticClass: "box-title"
      }, [_c('span', {
        staticClass: "grupoMostrarOcultar",
        on: {
          "click": function($event) {
            _vm.mostrar('atividade', (processo + '.' + atividade))
          }
        }
      }, [_c('i', {
        class: 'fa fa-caret-' + (!_vm._.isUndefined(_vm._.find(_vm.mostrarAtividade, function(p) {
          return p === (processo + '.' + atividade)
        })) ? 'up' : 'down'),
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.enumeradores[atividade])), _c('span', {
        staticClass: "contador"
      }, [_vm._v(_vm._s(_vm.totalTarefas(_vm.listaValidacoes[processo][atividade])))])])])]), _vm._v(" "), (!_vm._.isUndefined(_vm._.find(_vm.mostrarAtividade, function(p) {
        return p === (processo + '.' + atividade)
      }))) ? _c('div', {
        ref: processo + '.' + atividade,
        refInFor: true,
        staticClass: "box-body"
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.mostraProcessando),
          expression: "mostraProcessando"
        }],
        staticClass: "overlay box box-widget",
        staticStyle: {
          "position": "absolute",
          "top": "0px",
          "left": "0px",
          "width": "100%",
          "height": "100%",
          "display": "block"
        }
      }, [_c('i', {
        staticClass: "fa fa-refresh fa-spin"
      })]), _vm._v(" "), (true) ? _c('div', [_c('b-container', {
        attrs: {
          "fluid": ""
        }
      }, _vm._l(((_vm._.includes(['projeto', 'entidade'], _vm.ordenacao.por) ?
        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [function(termo) {
          return _vm._.lowerCase(termo[_vm.ordenacao.por])
        }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
        _vm._.includes(['valor'], _vm.ordenacao.por) ? // se for um valor deve converter primeiro antes de ordenar
        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [function(termo) {
          return parseFloat(termo[_vm.ordenacao.por])
        }, _vm.ordenacao.por], [_vm.ordenacao.ordem]) :
        _vm._.includes(['codigo_ocorrencia'], _vm.ordenacao.por) ? // se código de oorrência deve pegar no 'extra'
        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], ['extra.codigo_ocorrencia'], [_vm.ordenacao.ordem]) :
        _vm._.orderBy(_vm.listaValidacoes[processo][atividade], [_vm.ordenacao.por], [_vm.ordenacao.ordem]))), function(tarefa) {
        return _c('div', {
          staticClass: "row tarefa",
          style: ('border-left: 10px solid ' + (_vm.sinalizaCor(tarefa)))
        }, [_c('div', {
          staticClass: "col-lg-6 col-md-12 col-sm-12 col-xs-12",
          staticStyle: {
            "height": "46px"
          }
        }, [_c('div', {
          staticClass: "col-xs-2",
          staticStyle: {
            "padding": "2px 0"
          }
        }, [_c('span', {
          staticClass: "indicadores"
        }, [_c('i', {
          class: (_vm._.find(_vm.tarefasSelecionadas, ['id_processo', tarefa.id_processo]) ? 'fa fa-check-square-o' : 'fa fa-square-o') + ' selecao',
          attrs: {
            "aria-hidden": "true"
          },
          on: {
            "click": function($event) {
              return _vm.selecionarItem(tarefa)
            }
          }
        }), _vm._v(" "), _c('i', {
          class: (tarefa.favoritado === 'sim_fav' ? 'fa fa-star favorito' : 'fa fa-star-o'),
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" "), ((_vm._.get(tarefa.extra, 'chamados', [])).length === 1) ? _c('span', _vm._l((_vm._.get(tarefa.extra, 'chamados', [])), function(chamado) {
          return _c('a', {
            directives: [{
              name: "tippy",
              rawName: "v-tippy",
              value: ({
                inertia: true,
                arrow: true,
                animation: 'perspective',
                distance: '1',
                size: 'large',
                placement: 'top',
                interactive: true
              }),
              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top', interactive:true}"
            }],
            attrs: {
              "href": _vm.urlLaravel + '/cadastro/chamado/edita/' + chamado.id,
              "target": "_blank",
              "title": '<h5 class=\'text-left\'>Chamado SGP <span class=\'realce\'>' + chamado.id + '</span><br/>' + ((chamado.descricao).substr(0, 50) + (chamado.descricao.length > 50 ? '...' : '')) + '</h5>'
            }
          }, [_c('i', {
            staticClass: "fa fa-comments-o",
            attrs: {
              "aria-hidden": "true"
            }
          })])
        }), 0) : _vm._e(), _vm._v(" "), ((_vm._.get(tarefa.extra, 'chamados', [])).length > 1) ? _c('span', {
          staticClass: "dropup menu_chamados"
        }, [_c('span', {
          staticClass: "balao_chamado dropdown",
          attrs: {
            "data-toggle": "dropdown",
            "aria-haspopup": "true",
            "aria-expanded": "false"
          }
        }, [_c('span', [_c('i', {
          staticClass: "fa fa-comments-o",
          attrs: {
            "aria-hidden": "true"
          }
        })]), _vm._v(" "), _c('span', {
          staticClass: "contador_chamado"
        }, [_vm._v(_vm._s((_vm._.get(tarefa.extra, 'chamados', [])).length))])]), _vm._v(" "), _c('ul', {
          staticClass: "dropdown-menu"
        }, _vm._l((_vm._.get(tarefa.extra, 'chamados', [])), function(chamado) {
          return _c('li', {
            attrs: {
              "role": "menuitem"
            }
          }, [_c('a', {
            staticClass: "item_chamado",
            attrs: {
              "href": _vm.urlLaravel + '/cadastro/chamado/edita/' + chamado.id,
              "target": "_blank"
            }
          }, [_vm._v("\n                                                      Chamado SGP "), _c('span', {
            staticClass: "realce"
          }, [_vm._v(_vm._s(chamado.id))]), _vm._v(" "), _c('i', {
            staticClass: "fa fa-external-link"
          }), _c('br'), _vm._v(_vm._s(((chamado.descricao).substr(0, 50) + (chamado.descricao.length > 50 ? '...' : ''))))])])
        }), 0)]) : _vm._e(), _vm._v(" "), (!_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'parametros') && _vm._.find(tarefa.extra.parametros, ['parametro', 'SUPORTE_FBB'])) ? _c('span', _vm._l((_vm.parametroStringToObject(tarefa.extra.parametros, 'SUPORTE_FBB')), function(suporte) {
          return _c('span', [_c('a', {
            directives: [{
              name: "tippy",
              rawName: "v-tippy",
              value: ({
                inertia: true,
                arrow: true,
                animation: 'perspective',
                distance: '1',
                size: 'large',
                arrow: true,
                placement: 'top'
              }),
              expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
            }],
            attrs: {
              "href": 'https://suporte.fbb.org.br/ocomon/geral/mostra_consulta.php?numero=' + suporte.numero,
              "target": "_blank",
              "title": '<h5>Suporte FBB <span class=\'realce\'>' + suporte.numero + '</span><br/>' + suporte.local + ' para ' + suporte.areaoper + '<br/>' + suporte.problema + '</h5>'
            }
          }, [_c('i', {
            staticClass: "fa fa-commenting-o",
            attrs: {
              "aria-hidden": "true"
            }
          })])])
        }), 0) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
          staticClass: "text-muted",
          domProps: {
            "innerHTML": _vm._s(tarefa.id_processo)
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "col-xs-10"
        }, [_c('div', {
          staticClass: "projeto truncar",
          domProps: {
            "innerHTML": _vm._s(tarefa.projeto)
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "entidade truncar",
          domProps: {
            "innerHTML": _vm._s(tarefa.entidade)
          }
        })])]), _vm._v(" "), _c('div', {
          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-6 text-center",
          staticStyle: {
            "height": "46px",
            "padding": "2px 0"
          }
        }, [(_vm._.includes(['ALTERACOES_PROJETO'], processo)) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              placement: 'top'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', placement:'top'}"
          }],
          attrs: {
            "title": '<h5>' +
              ((_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length === 0 ? ((_vm._.get(tarefa, 'extra.solicitacao.justificativa', '')).substr(0, 100) + '...') :
                (_vm._.join(_vm._.orderBy(_vm._.uniq(_vm._.map(_vm._.get(tarefa.extra.solicitacao, 'processos', []), function(p) {
                  return _vm.enumeradores[p.nome]
                })), null, ['asc']), ', '))) + '</h5>'
          }
        }, [_vm._v("\n                      " + _vm._s((_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length > 1 ? (_vm._.get(tarefa.extra.solicitacao, 'processos', [])).length + ' processos' : '1 processo') + "\n                    ")]) : (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('span', [(!_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'situacao_projeto')) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              placement: 'top'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
          }],
          style: ('font-weight: bold; color:' + (tarefa.extra.situacao_projeto === 'APR' ? 'var(--cor-destaque)' : 'var(--cor-atencao)')),
          attrs: {
            "title": '<h5>' + tarefa.extra.descricao_situacao + '</h5>'
          }
        }, [_vm._v("\n                        " + _vm._s(tarefa.extra.situacao_projeto) + "\n                      ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm._.has(tarefa.extra, 'codigo_ocorrencia')) ? _c('span', {
          staticClass: "text-bold"
        }, _vm._l(([(_vm._.get(tarefa, 'extra.codigo_ocorrencia')).substr(0, 1)]), function(nivel) {
          return _c('span', {
            style: ('color: var(--cor-' + (nivel === '4' ? 'atencao' : (nivel === '3' ? 'alerta' : (nivel === '2' ? 'destaque' : 'fraca'))) + ')')
          }, [_vm._v("\n                        " + _vm._s(_vm._.get(tarefa, 'extra.codigo_ocorrencia')) + "\n                      ")])
        }), 0) : _c('span', {
          domProps: {
            "innerHTML": _vm._s(tarefa.info)
          }
        })]), _vm._v(" "), _c('div', {
          class: (_vm._.includes(['SOLICITACOES'], _vm.validacao) ? 'col-lg-2 col-md-4 col-sm-4 col-xs-6' : 'col-lg-2 col-md-6 col-sm-5 col-xs-6') + ' text-center',
          staticStyle: {
            "height": "46px"
          }
        }, [(atividade === 'FINALIZADAS') ? _c('div', {
          staticClass: "aprovado_por usuario"
        }, [_vm._v("Aprovado por"), _c('br'), _c('div', {
          staticClass: "truncar",
          domProps: {
            "innerHTML": _vm._s(tarefa.nome_usuario)
          }
        })]) : _c('div', [(tarefa.nome_usuario) ? _c('div', {
          staticClass: "usuario",
          domProps: {
            "innerHTML": _vm._s(tarefa.nome_usuario)
          }
        }) : _c('div', {
          staticClass: "text-muted"
        }, [_vm._v("Aguardando atendimento")])])]), _vm._v(" "), (_vm._.includes(['SOLICITACOES'], _vm.validacao)) ? _c('div', {
          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-4 text-left",
          staticStyle: {
            "height": "46px"
          }
        }, [(_vm._.includes(['PAGAMENTO', 'PRESTACAO_DE_CONTAS', 'RESSARCIMENTO'], processo)) ? _c('span', [(_vm._.includes(['AUTORIZACAO', 'ANALISE_TRIBUTARIA', 'LIQUIDACAO_FINANCEIRA'], atividade)) ? _c('span', [_c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              placement: 'top'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
          }],
          attrs: {
            "title": '<h5>Tributado: <span class=\'realce\'>' + (_vm._.get(_vm._.last(_vm._.filter(tarefa.extra.parametros, ['parametro', 'TRIBUTACAO'])), 'valor') === 'TRIBUTADO' ? 'Sim' : 'Não') + '</span></h5>'
          }
        }, [_vm._v("\n                          " + _vm._s(_vm._f("real")(tarefa.valor)) + "\n                        ")]), _vm._v(" "), (atividade === 'AUTORIZACAO' && !_vm._.isNull(tarefa.extra) && _vm._.has(tarefa.extra, 'parametros') && _vm._.find(tarefa.extra.parametros, ['parametro', 'VALOR_TRIBUTADO'])) ? _c('span', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true,
              placement: 'top'
            }),
            expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', arrow:true, placement:'top'}"
          }],
          staticStyle: {
            "color": "var(--cor-destaque)"
          },
          attrs: {
            "title": '<h5>Valor Líquido</h5>'
          }
        }, [_c('br'), _vm._v(_vm._s(_vm._f("real")(tarefa.valor - (_vm._.toNumber(_vm._.get(_vm._.last(_vm._.filter(tarefa.extra.parametros, ['parametro', 'VALOR_TRIBUTADO'])), 'valor'))))) + "\n                        ")]) : _vm._e()]) : _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))])]) : _c('span', [_vm._v(_vm._s(_vm._f("real")(tarefa.valor)))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "col-lg-1 col-md-2 col-sm-2 col-xs-4 text-right",
          staticStyle: {
            "height": "46px"
          }
        }, [(_vm._.isNull(tarefa.data_solicitacao)) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.inicio, "DD/MM/YYYY HH:mm")))]) : _c('span', [_vm._v(_vm._s(_vm._f("moment")(tarefa.data_solicitacao, "DD/MM/YYYY HH:mm")))])]), _vm._v(" "), _c('div', {
          class: (_vm._.includes(['SOLICITACOES'], _vm.validacao) ? 'col-lg-1 col-md-2 col-sm-2 col-xs-4' : 'col-lg-2 col-md-2 col-sm-3 col-xs-8') + ' text-right',
          staticStyle: {
            "height": "46px",
            "padding": "2px 0"
          }
        }, [_c('g-button-ujarak', {
          directives: [{
            name: "tippy",
            rawName: "v-tippy",
            value: ({
              inertia: true,
              arrow: true,
              animation: 'perspective',
              distance: '1',
              size: 'large',
              arrow: true
            }),
            expression: "{ inertia : true, arrow : true,  animation : 'perspective', distance:'1', size: 'large', arrow : true }"
          }],
          attrs: {
            "color": "primary",
            "size": "button--size-ss",
            "title": '<h5>Assumir e Fazer</h5>'
          },
          nativeOn: {
            "click": function($event) {
              return _vm.verificarAtribuicao(tarefa)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil",
          attrs: {
            "aria-hidden": "true"
          }
        })])], 1)])
      }), 0)], 1) : _vm._e()]) : _vm._e()])
    }), 0) : _vm._e()])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('strong', [_vm._v("Selecione o funcionário:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-206b71cb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/solicitacoes/ListaValidacaoSolicitacoes.vue
// module id = 1794
// module chunks = 2